import { LANGUAGES, Language } from '../i18n/catalogs';
import { useI18n } from '../i18n/I18nProvider';

export interface FooterProps {
  version: string;
  year: number;
  onOpenChangelog(): void;
}

export function Footer({ version, year, onOpenChangelog }: FooterProps): JSX.Element {
  const { language, setLanguage, t } = useI18n();
  const copyright = `© ${year} OptimaGroup`;

  return (
    <footer className="footer" data-testid="app-footer">
      <div className="footer__left">
        <span className="footer__copyright">{copyright}</span>
        <button
          type="button"
          className="footer__version"
          onClick={onOpenChangelog}
          title={t('footerChangelogHint')}
          aria-label={t('footerChangelogHint')}
        >
          {`${t('footerVersionLabel')} v${version}`}
        </button>
      </div>
      <div className="footer__right">
        <span className="footer__lang-label">{t('languageLabel')}</span>
        <div className="lang-switch" role="group" aria-label={t('languageLabel')}>
          {LANGUAGES.map((code: Language) => (
            <button
              key={code}
              type="button"
              className={`lang-switch__btn${code === language ? ' is-active' : ''}`}
              aria-pressed={code === language}
              data-lang={code}
              onClick={() => setLanguage(code)}
            >
              {code.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </footer>
  );
}
